import { render } from "./RemoteImageEditor.vue?vue&type=template&id=229734e9&scoped=true&ts=true"
import script from "./RemoteImageEditor.vue?vue&type=script&lang=ts"
export * from "./RemoteImageEditor.vue?vue&type=script&lang=ts"

import "./RemoteImageEditor.vue?vue&type=style&index=0&id=229734e9&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229734e9"]])

export default __exports__